const TOKEN_KEY = import.meta.env.VITE_TOKEN_STORAGE_KEY || 'popin_token'
const USERID_KEY = 'popin_userid'
const SESSION_KEY = 'popin_session'
const ROLE_KEY = 'popin_role'

export const storage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),

  getUserId: () => localStorage.getItem(USERID_KEY),
  setUserId: (id) => localStorage.setItem(USERID_KEY, String(id)),
  clearUserId: () => localStorage.removeItem(USERID_KEY),

  getSession: () => {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  },
  setSession: (s) => localStorage.setItem(SESSION_KEY, JSON.stringify(s)),
  clearSession: () => localStorage.removeItem(SESSION_KEY),

  getRole: () => localStorage.getItem(ROLE_KEY),
  setRole: (r) => localStorage.setItem(ROLE_KEY, r),
  clearRole: () => localStorage.removeItem(ROLE_KEY),

  clearAll: () => {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USERID_KEY)
    localStorage.removeItem(SESSION_KEY)
    localStorage.removeItem(ROLE_KEY)
  },
}
